<template>
  <div class="tradeTable">
    <div class="tabContaner">
      <el-table
      :data="assettable"
      stripe
      :header-row-style="bg"
      style="width:100%">
      <el-table-column
        prop="amount"
        label="提现金额"
        :formatter="toFloat"
        header-align="center"
        align="center">
      </el-table-column>
      <el-table-column
        prop="realAmount"
        label="收款金额"
        :formatter="toFloat"
        header-align="center"
        align="center">
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="提现时间"
        header-align="center"
        align="center">
      </el-table-column>
      <el-table-column
        prop="subject"
        label="提现渠道"
        header-align="center"
        align="center">
      </el-table-column>
      <el-table-column
        prop="status"
        label="提现进度"
        width="300"
        :formatter="statusFormat"
        header-align="center"
        align="center">
        <!--<template slot-scope="scope">-->
          <!--<div>{{chooseType(scope.row.status)}}</div>-->
        <!--</template>-->
      </el-table-column>
      <el-table-column
        prop="date"
        label="操作"
        header-align="center"
        align="center">
          <template slot-scope="scope">
            <span type="small" class="operation" @click="handleEdit(scope.$index, scope.row)">查看详情</span>
          </template>
      </el-table-column>
    </el-table>
  </div>
  </div>
</template>
<script>
import { toFloat } from "@/utils";

export default {
  props: ["assettable"],
  components: {},
  data() {
    return {
      bg: {
        "background-color": "#fafafa"
      }
    };
  },
  methods: {
    toFloat(row, column, cellValue) {
      return toFloat(cellValue);
    },
    handleEdit(index, row) {
      let { status, order_id } = row;
      this.$store.commit('SET_ORDER_ID', order_id);
      if (status === 0) {
        //发起提现等待审核
        this.$router.push({
          path: "/main/indexshow/withdraw/WithdrawTwo",
        });
      }
      if (status === 1) {
        //审核通过等待发票
        this.$router.push({
          path: "/main/indexshow/withdraw/WithdrawThree",
          query: { order: order_id }
        });
      }
      if (status === 2) {
        //发票审核通过等待收款
        this.$router.push({
          path: "/main/indexshow/withdraw/WithdrawThree",
          query: { order: order_id }
        });
      }
      if (status === 3) {
        //提现成功
        this.$router.push({
          path: "/main/indexshow/withdraw/WithdrawSix",
          query: { order: order_id }
        });
      }
      if (status === 4) {
        //提现失败
        this.$router.push({
          path: "/main/indexshow/withdraw/WithdrawError",
          query: { order: order_id }
        });
      }
    },
    chooseType(type) {
      if (type === 0) {
        return "发起提现等待审核";
      } else if (type === 2) {
        return "发票审核通过等待收款";
      } else if (type === 3) {
        return "提现成功（财务已打款）";
      } else if (type === 4) {
        return "提现失败";
      } else if (type === 1) {
        return "审核通过等待发票";
      }
    },
    statusFormat(row, column) {
      let status = row[column.property];
      let str = "";
      switch (status) {
        case 0:
          str = "待审核";
          break;
        case 1:
          str = "待交发票";
          break;
        case 2:
          str = "待收款";
          break;
        case 3:
          str = "提现成功";
          break;
        case 4:
          str = "审核失败";
          break;
        default:
          str = "未知状态";
          break;
      }
      return str;
    }
  }
};
</script>
<style lang="scss" scoped>
.tradeTable {
  // width: 100%;
  margin-top: 10px;
  margin: 0 20px;
}
.bgFa {
  background-color: #fafafa;
}
.tabContaner {
  width: 100%;
}
.operation {
  cursor: pointer;
  color: #239bfa;
}
</style>



// WEBPACK FOOTER //
// src/components/AssetTable.vue